<template>
  <div>
    <input type="checkbox" v-model="row.selected" @change="emitSelected" />
  </div>
</template>
<script>
import eventBus from "../../eventbus";

export default {
  props: ["row"],
  data: function() {
    return {
      selected: false
    };
  },
  methods: {
    emitSelected() {
      if (this.row.selected) {
        eventBus.$emit("selected", this.row);
      } else {
        eventBus.$emit("deselected", this.row);
      }
    }
  },
  created: function() {
    eventBus.$on("select-all", selected => {
      this.row.selected = true;
    });

    eventBus.$on("deselect-all", selected => {
      this.row.selected = false;
    });
  }
};
</script>
